const sodaTheme = {
  '--bg-error': '#fddcda',
  '--gray-100': '#19191d',
  '--color-tap': '#f2fbf3',
  '--font-size': '1rem',
  '--bg-warning': '#fff8ea',
  '--light-grey': '#ebf1f5',
  '--bg-skeleton': '#e4e4e4',
  '--color-white': 'rgba(255, 255, 255, 1)',
  '--font-size-l': '1.25rem',
  '--font-size-m': '0.875rem',
  '--font-size-s': '0.75rem',
  '--alertas-info': '#2a4737',
  '--color-text-1': '#2a4737',
  '--font-size-xl': '1.4rem',
  '--font-size-xs': '0.625rem',
  '--alertas-error': '#f44336',
  '--alertas-exito': '#43a047',
  '--bg-successful': '#dff0d8',
  '--color-azul-02': '#5eca6f',
  '--color-brand-1': '#92e09e',
  '--color-brand-2': '#92e09e7d',
  '--color-brand-3': '#92e09e',
  '--color-brand-4': '#00B766',
  '--color-brand-5': '#61D47E',
  '--color-brand-6': '#ADEB91',
  '--color-brand-7': '#C9ED97',
  '--color-brand-8': '#E6F19E',
  '--color-primary': '#2a4737',
  '--font-size-xxl': '1.813rem',
  '--accent-blue-01': '#c3efc9',
  '--accent-blue-02': '#e0f8e3',
  '--accent-blue-03': '#a5d6a7',
  '--accent-blue-04': '#92e09e',
  '--btn-primary-bg': '#92e09e',
  '--color-disabled': '#ccc',
  '--fondos-celeste': '#f7f7ec',
  '--letter-spacing': '0rem',
  '--fondos-naranjas': '#fffff5',
  '--accent-orange-01': '#2a4737',
  '--accent-orange-02': '#3a614b',
  '--accent-orange-03': '#5eca6f',
  '--accent-orange-04': '#4d7c5f',
  '--accent-orange-05': '#efff85',
  '--btn-primary-text': '',
  '--color-successful': '#43a047',
  '--color-text-black': '#000000',
  '--font-family-base': 'Plus Jakarta Sans',
  '--elementos-ui-gris': '#eee',
  '--border-radius-card': '1.25rem',
  '--btn-primary-border': '',
  '--color-primary-dark': '#f7f7ec',
  '--color-text-primary': '#666',
  '--color-text-summary': '#000',
  '--color-text-warning': '#ffb41f',
  '--text-transform-tap': 'capitalize',
  '--alertas-advertencia': '#ffb41f',
  '--alertas-error-claro': '#fff6f6',
  '--alertas-exito-claro': '#fff8ea',
  '--border-radius-input': '0.5rem',
  '--color-text-disabled': '#aaa',
  '--light-high-contrast': '#324552',
  '--text-transform-link': 'capitalize',
  '--border-radius-select': '0.5rem',
  '--btn-primary-bg-hover': '#c3efc9',
  '--color-primary-action': '#5eca6f',
  '--dark-medium-contrast': '#acbac3',
  '--elementos-ui-azul-01': '#2a4737',
  '--elementos-ui-azul-02': '#4d7c5f',
  '--elementos-ui-azul-03': '#E0E0E0',
  '--elementos-ui-azul-05': '#f2fbf3',
  '--dark-color-background': '#111b22',
  '--light-medium-contrast': '#566976',
  '--marca-naranja-connect': '#2a4737',
  '--nav-bar-blue-disabled': '#c3efc9',
  '--nav-bar-blue-progress': '#5eca6f',
  '--shadow-button-rounded':
    '0px 0px 0px 0px rgba(43, 168, 74, 0.1), 2px 3px 8px 0px rgba(43, 168, 74, 0.1), 6px 13px 14px 0px rgba(43, 168, 74, 0.09), 14px 29px 19px 0px rgba(43, 168, 74, 0.05), 25px 51px 23px 0px rgba(43, 168, 74, 0.01), 40px 79px 25px 0px rgba(43, 168, 74, 0)',
  '--text-transform-button': 'capitalize',
  '--btn-primary-text-hover': '',
  '--color-primary-disabled': '#e0f8e3',
  '--border-radius-btn-cupon': '0.5rem',
  '--btn-primary-bg-disabled': '',
  '--elementos-ui-naranja-01': '#3a614b',
  '--elementos-ui-naranja-03': '#92e09e',
  '--elementos-ui-naranja-04': '#c3efc9',
  '--elementos-ui-naranja-05': '#EFFF85',
  '--border-radius-item-price': '0.5rem',
  '--btn-primary-border-hover': '',
  '--color-background-primary': '#f7f7ec',
  '--color-disabled-secondary': '#fbfbf6',
  '--alertas-advertencia-claro': '#fff8ea',
  '--btn-primary-text-disabled': '',
  '--shadow-button-rounded-alt':
    '0px 0px 0px 0px rgba(10, 81, 46, 0.1), 2px 3px 8px 0px rgba(10, 81, 46, 0.1), 6px 13px 14px 0px rgba(10, 81, 46, 0.09), 14px 29px 19px 0px rgba(10, 81, 46, 0.05), 25px 51px 23px 0px rgba(10, 81, 46, 0.01), 40px 79px 25px 0px rgba(10, 81, 46, 0)',
  '--border-radius-item-payment': '0.5rem',
  '--color-text-disabled-secondary': '#b7b7b7',
  '--light-component-background-01': '#ffffff',
  '--text-transform-title-checkout': 'none',
  '--text-transform-detail-accordion': 'capitalize',
  '--text-transform-summary-checkout': 'none',
  '--text-transform-item-price-checkout': 'capitalize',
  '--text-transform-title-price-checkout': 'none',
  '--text-transform-header-steps-checkout': 'capitalize',
  '--header-steps-color-disabled': '#535353',
  '--secondary-btn-color': '#f44336',
  '--secondary-btn-background': '#ffffff',
  '--secondary-btn-border': '#ffffff',
};

export default sodaTheme;
